import { authService, PATH_DICTIONARY } from '~/domains/auth';
import { useRouter } from '~/infrastructure';

interface UseLogoutReturn {
  logout: (needRedirect?: boolean) => Promise<void>;
}

export default function useLogout(): UseLogoutReturn {
  const router = useRouter();

  const logout = async (needRedirect: boolean = true): Promise<void> => {
    await authService.logout();
    if (needRedirect) router.push(PATH_DICTIONARY.login);
  };

  return {
    logout,
  };
}
